import { Directive, Input } from '@angular/core';
import { LayoutElementDirective } from './layout-element.directive';

@Directive({
  selector: '[am-layout-left]',
})
export class LayoutLeftDirective extends LayoutElementDirective {
  @Input() width = '300px';
}
